import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IBrandDetails } from 'src/app/core/domain/brand.model';

@Component({
  selector: 'app-challenges-success',
  templateUrl: './challenges-success.component.html',
  styleUrls: ['./challenges-success.component.scss']
})
export class ChallengesSuccessComponent implements OnInit {
  redirectUrl = '/auth/login';
  brandDetails: Partial<IBrandDetails> = {};
  @Input() corporateProfileConfirmation:boolean

  constructor(private router: Router) { 
    console.log(this.corporateProfileConfirmation)
  }

   ngOnInit(): void {
    setTimeout(() => {
      if(this.corporateProfileConfirmation){
      this.router.navigateByUrl(this.redirectUrl);
      }else{
      this.router.navigateByUrl('/search_challenges');
      }
    }, 10000);
  }

 goHome(): void {
    this.router.navigateByUrl(this.redirectUrl);
  }
}
